"use client";

import PicFrame from "../PicFrame";
import AR from "@/public/image/main-Slider.jpg"
import { ARIcon } from "../iconComponents/ARIcon";
import { text } from "@/static/text";
import LandingSection from "../LandingSection";

export default function ARSection(){
    return(
      <LandingSection 
        tagTitle={text.ARSection.tag} 
        tagIconName="eye"
        title={text.ARSection.title}
        desc={text.ARSection.desc}
      >
          <PicFrame 
            icon={ARIcon} 
            btnText={text.ARSection.btn} 
            href="/product?ar=true"
            imageSrc={AR}
            imageAlt="AR"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
      </LandingSection>
    )
}
